"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _themeUi = require("theme-ui");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tether = function Tether(_ref) {
  var children = _ref.children,
      tetherComponent = _ref.tetherComponent,
      sourceAnchorCoord = _ref.sourceAnchorCoord,
      tetherAnchorCoord = _ref.tetherAnchorCoord,
      fitInViewport = _ref.fitInViewport,
      shouldUpdatePosition = _ref.shouldUpdatePosition,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "tetherComponent", "sourceAnchorCoord", "tetherAnchorCoord", "fitInViewport", "shouldUpdatePosition"]);

  var _useState = (0, _react.useState)(false),
      flippedX = _useState[0],
      setFlippedX = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      flippedY = _useState2[0],
      setFlippedY = _useState2[1];

  var sourceEl = (0, _react.useRef)();
  var documentWindowEl = window;
  var tetherEl = (0, _react.useRef)(document.createElement('div'));
  (0, _react.useEffect)(function () {
    var element = tetherEl.current;
    element.style.position = 'absolute';
    document.body.appendChild(element);
    return function () {
      document.body.removeChild(element);
    };
  }, []);

  var convertElOriginToPixels = function convertElOriginToPixels(origin, el) {
    var convertedOrigin = [];

    for (var axis in origin) {
      var value = origin[axis];

      if (typeof value === 'number') {
        convertedOrigin.push(value);
      } else if (typeof value === 'string') {
        if (value.indexOf('%') >= 0) {
          var elemDimension = axis === 'x' ? el.offsetWidth : el.offsetHeight;
          convertedOrigin.push(elemDimension * parseFloat(value) / 100);
        } else {
          convertedOrigin.push(parseFloat(value));
        }
      }
    }

    return convertedOrigin;
  };

  (0, _react.useLayoutEffect)(function () {
    if (!sourceEl.current || !shouldUpdatePosition) {
      return;
    }

    var fitsWithinViewport = function fitsWithinViewport(xMin, yMin, xMax, yMax) {
      var result = {
        xMin: true,
        yMin: true,
        xMax: true,
        yMax: true
      };

      if (xMin < 0) {
        result.xMin = false;
      }

      if (xMax > document.documentElement.scrollWidth) {
        result.xMax = false;
      }

      if (yMin < 0) {
        result.yMin = false;
      }

      if (yMax > document.documentElement.scrollWidth) {
        result.yMax = false;
      }

      return result;
    };

    var getPosition = function getPosition() {
      var _sourceEl$current$get = sourceEl.current.getBoundingClientRect(),
          top = _sourceEl$current$get.top,
          left = _sourceEl$current$get.left;

      var topToSource = Math.floor(top);
      var leftToSource = Math.floor(left);
      var convertedSourceAnchor = convertElOriginToPixels(sourceAnchorCoord, sourceEl.current);
      var convertedTetherAnchor = convertElOriginToPixels(tetherAnchorCoord, tetherEl.current);
      var slaveLeft = leftToSource + convertedSourceAnchor[0];
      var slaveTop = topToSource + convertedSourceAnchor[1];
      slaveLeft -= convertedTetherAnchor[0];
      slaveTop -= convertedTetherAnchor[1];
      var hasFlippedX = false;
      var hasFlippedY = false;

      if (fitInViewport) {
        var _fitsWithinViewport = fitsWithinViewport(slaveLeft, slaveTop, slaveLeft + tetherEl.current.offsetWidth, slaveTop + tetherEl.current.offsetHeight),
            xMin = _fitsWithinViewport.xMin,
            yMin = _fitsWithinViewport.yMin,
            xMax = _fitsWithinViewport.xMax,
            yMax = _fitsWithinViewport.yMax;

        if (!xMin) {
          slaveLeft += convertedTetherAnchor[0] - convertedSourceAnchor[0];
          hasFlippedX = true;
        }

        if (!xMax) {
          slaveLeft -= tetherEl.current.offsetWidth + convertedSourceAnchor[0];
          hasFlippedX = true;
        }

        if (!yMin) {
          slaveTop += convertedTetherAnchor[1] - convertedSourceAnchor[1];
          hasFlippedY = true;
        }

        if (!yMax) {
          slaveTop -= tetherEl.current.offsetHeight + convertedSourceAnchor[1];
          hasFlippedY = true;
        }
      }

      setFlippedX(hasFlippedX);
      setFlippedY(hasFlippedY);
      slaveLeft += window.pageXOffset;
      slaveTop += window.pageYOffset;
      tetherEl.current.style.top = slaveTop + "px";
      tetherEl.current.style.left = slaveLeft + "px";
    };

    getPosition();
    documentWindowEl.addEventListener('resize', getPosition);
    documentWindowEl.addEventListener('scroll', getPosition);
    return function () {
      documentWindowEl.removeEventListener('resize', getPosition);
      documentWindowEl.removeEventListener('scroll', getPosition);
    };
  }, [documentWindowEl, fitInViewport, sourceAnchorCoord, tetherAnchorCoord, shouldUpdatePosition]);
  var tetherComponentActual = _react["default"].isValidElement(tetherComponent) ? tetherComponent : tetherComponent({
    flippedX: flippedX,
    flippedY: flippedY
  });
  return (0, _themeUi.jsx)(_react.Fragment, null, (0, _themeUi.jsx)("div", _extends({}, props, {
    ref: sourceEl,
    sx: {
      display: 'inline-flex'
    }
  }), children), (0, _reactDom.createPortal)(tetherComponentActual, tetherEl.current));
};

Tether.propTypes = {
  children: _propTypes["default"].node.isRequired,
  tetherComponent: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,
  sourceAnchorCoord: _propTypes["default"].shape({
    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  tetherAnchorCoord: _propTypes["default"].shape({
    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  fitInViewport: _propTypes["default"].bool,
  shouldUpdatePosition: _propTypes["default"].bool
};
Tether.defaultProps = {
  fitInViewport: false,
  shouldUpdatePosition: true,
  sourceAnchorCoord: {
    x: 0,
    y: '100%'
  },
  tetherAnchorCoord: {
    x: 0,
    y: 0
  }
};
var _default = Tether;
exports["default"] = _default;